module.exports = __webpack_public_path__ + "static/assets/2efea14008b6c49d7bf7901a4db465ae.svg";